import React from 'react'
import "../Styles/Bookmarked.css"
import Rajasthan from "../Images/rajasthan_pic.png"
import Bookmarked_img from "../Images/bookmarked.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from "@fortawesome/free-solid-svg-icons"
import { BookmarkedContext } from '../Context/BookmarkedContext.jsx'
import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

function Bookmarked() {
  const navigate=useNavigate();
  const {bookmarkedItems, removeBookmark} = useContext(BookmarkedContext);
  console.log("bookmarkedItems:", bookmarkedItems);
  return (
    <div>

{
  bookmarkedItems?
  bookmarkedItems.map((item)=>(
      <div class="tripCard_wrapper">
        <div class="tripCard_image">
          <img src={item?.destination?.featured_photo} alt="Rajasthan Tour" />
        </div>
        <div class="tripCard_content">
          <h4 class="tripCard_title">{item?.title}</h4>
          <p class="tripCard_date" style={{fontWeight:"600"}}>₹ {item?.finalPrice}/-</p>
          <div class="tripCard_buttons">
            <button class="tripCard_btnDetails"  onClick={() => {
  if (item.trip_type_id === 3 ) {
    navigate(`/tour/packagetour/${item?.id}`);
  }else if (item.trip_type_id ===5) {
    navigate(`/tour/grouptour/${item?.id}`);
  }else if (item.trip_type_id ===2) {
    navigate(`/tour/weekendtour/${item?.id}`);
  }
   else {
    navigate(`/tour/plantour/${item?.id}`);
  }
}}>View details</button>
 

            <button class="tripCard_btnCancel"  onClick={()=>removeBookmark(item?.id)}>Remove</button>
             <FontAwesomeIcon icon={faBookmark} style={{display:"block",position:"absolute",top:"5",right:"5",fontSize:"25px"}}/>
          </div>

        </div>


      </div>
  )
  ):
  <div>No Bookmarked Items</div>
}




    </div>
  )
}

export default Bookmarked